import { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import base64 from 'base-64';
import { useGlobalContext } from '../context/GlobalContext';
//import { jwtDecode } from 'jwt-decode';

const useHttp = () => {

    const { logout } = useAuth();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [{ config }, dispatch] = useGlobalContext();

    const http = axios.create({
        baseURL: process.env.REACT_APP_BACKEND_URL,
        timeout: 20000,
        // Headers will be set for each request below, not here.
        cancelToken: source.token
    });

    // Add a request interceptor
    http.interceptors.response.use(response => {
        // Any status code within the range of 2xx cause this function to trigger
        return response;
    }, error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger        
        if (error.response && error.response.status === 401) {
            // Remove user from localStorage if 401 Unauthorized response
            localStorage.removeItem('user');
            logout();
        }
        console.log("Error en http.js", error);
        // Return any error which is not due to authentication back to the calling service
        return Promise.reject(error);
    });


    /* const handleTokenExpiry = () => {
        dispatch({
            type: 'UPDATE_CONFIG',
            payload: { isTokenValid: false }
        });
    };

    const isTokenExpired = () => {
        const token = config?.token;
        if (!token) {
            handleTokenExpiry(dispatch);
            return true; // If there's no token, consider it expired
        }

        try {
            const decodedToken = jwtDecode(token);
            const currentTime = Date.now() / 1000; // Current time in seconds since the Unix epoch

            if (decodedToken.exp < currentTime) {
                handleTokenExpiry(dispatch);
                return true;
            }

            return false;
        } catch (error) {
            console.error("Invalid token:", error);
            handleTokenExpiry(dispatch);
            return true; // Consider the token expired if it can't be decoded
        }
    };
 */

    const get = async (url, params, auth = null) => {
        //const token = await JSON.parse(localStorage.getItem('user'));

        const token = config?.token;
        const headers = {
            'x-movil-token': token
        };

        if (auth) {
            const { username, password } = auth;
            const encodedCredentials = base64.encode(`${username}:${password}`);
            headers['Authorization'] = `Basic ${encodedCredentials}`;
        }

        return http.get(url, {
            ...params,
            headers: headers
        });
    }

    const refreshToken = async () => {
        setIsRefreshing(true);
        try {
            //const user = JSON.parse(localStorage.getItem('user'));
            const token = config?.token;
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/users/refresh`, {}, {
                headers: {
                    'x-movil-token': token,
                },
            });
            //console.log("Response from refresh token", response.data);
            const newToken = response.data.token;
            const updatedUser = { ...config, token: newToken };

            localStorage.setItem('user', JSON.stringify(updatedUser));
            //console.log("Actualizando token en config");
            dispatch({
                type: 'UPDATE_CONFIG',
                payload: { token: newToken }
            });
            return newToken;
        } catch (error) {
            console.error("Failed to refresh token", error);
            logout();
            return error;
        } finally {
            setIsRefreshing(false);
        }
    };

    const post = async (url, data) => {
        //const user = await localStorage.getItem('user');
        const token = config?.token;
        return http.post(url, data, {
            headers: {
                'x-movil-token': token,
            },
        });
    }

    const patch = async (url, data, auth = null) => {
        //const user = await localStorage.getItem('user');
        const token = config?.token;
        const headers = {
            'x-movil-token': token
        };

        if (auth) {

            const { username, password } = auth;
            const encodedCredentials = base64.encode(`${username}:${password}`);
            headers['Authorization'] = `Basic ${encodedCredentials}`;
        }

        return http.patch(url, data, {
            ...data,
            headers: headers
        });
    }

    const put = async (url, data) => {
        //const user = await localStorage.getItem('user');
        const token = config?.token;
        return http.put(url, data, {
            headers: {
                'x-movil-token': token,
            },
        });
    }

    const del = async (url, data) => {
        const user = await localStorage.getItem('user');
        return http.delete(url, {
            data,
            headers: {
                'x-movil-token': JSON.parse(user).token,
            },
        });
    }

    const abort = () => source.cancel('Operation canceled by the user.');

    return { get, post, put, del, abort, patch, refreshToken, isRefreshing, /* isTokenExpired */ };

};

export default useHttp;